import { Component, Input} from "@angular/core";

declare var $ : any;
@Component({
    selector: "app-tooltip",
    templateUrl: "./tooltip.component.html",
    styleUrls: ['./tooltip.component.css']
})

export class TooltipComponent{
    constructor(){

    }

    @Input('address') address: string;
    @Input('lengthsplice') lengthsplice: number;
    @Input('index') index: number;
    @Input('label') label: string ;
    @Input('inputList') inputList: any = [] ;
    @Input('isList') isList: boolean = false;

    ngOnInit(){
        this.enableTooltip();
        
    }

    ngOnChanges(){
        this.enableTooltip();
    }

    enableTooltip() {
        this.hideTooltip();
        setTimeout(function () {
            //   $(".content").mCustomScrollbar("update");
            $('.tip1').each(function () {
                $(this).tooltip(
                    {
                        html: true,
                        trigger: "hover",
                        title: $('#' + $(this).attr('data-tip')).html(),
                        customClass: 'tooltip-custom'
                    });
            });

            // $('.tip1').on('click', function () {
            //     $(this).tooltip('hide');
            // });
        }, 3 * 1000)
    }
    hideTooltip() {
        $('.tip1').each(function () {
            $(this).tooltip('hide');
        });
    }
    

}